// extracted by mini-css-extract-plugin
export var avatarContainer = "_5r-1";
export var largeAvatarContainer = "_5r-2";
export var smallAvatarContainer = "_5r-0";